import { useCallback, useState } from 'react';
import api from '../api/client';

export function useApi() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const request = useCallback(async (method, url, data, config) => {
    setLoading(true);
    setError(null);
    try {
      const res = await api({ method, url, data, ...config });
      return res.data;
    } catch (err) {
      const msg = err.response?.data?.detail || err.message;
      setError(msg);
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  const get = useCallback((url, cfg) => request('get', url, undefined, cfg), [request]);
  const post = useCallback((url, data, cfg) => request('post', url, data, cfg), [request]);
  const put = useCallback((url, data, cfg) => request('put', url, data, cfg), [request]);
  const patch = useCallback((url, data, cfg) => request('patch', url, data, cfg), [request]);
  const del = useCallback((url, cfg) => request('delete', url, undefined, cfg), [request]);

  return { get, post, put, patch, del, loading, error };
}
